import MealCard from './MealCard';

/**
 * Renders a list of meal cards, or an empty-state message.
 * `renderCardExtra(meal)`, if given, renders extra content inside the card
 * (e.g. a guest count line). `renderFooter(meal)`, if given, renders extra
 * content below each card (e.g. a review button, a guest-list toggle)
 * wrapped in a shared meal-card-wrapper div.
 */
const MealCardList = ({ meals, onSelect, emptyMessage, renderCardExtra, renderFooter, children }) => {
  if (meals.length === 0) {
    return children || <p className="meals-empty">{emptyMessage}</p>;
  }

  return (
    <div className="meals-list">
      {meals.map((meal) => {
        const footer = renderFooter ? renderFooter(meal) : null;
        const card = (
          <MealCard meal={meal} onClick={() => onSelect(meal)}>
            {renderCardExtra ? renderCardExtra(meal) : null}
          </MealCard>
        );

        if (!footer) {
          return <div key={meal.id}>{card}</div>;
        }

        return (
          <div key={meal.id} className="meal-card-wrapper">
            {card}
            {footer}
          </div>
        );
      })}
    </div>
  );
};

export default MealCardList;
